module.exports = __webpack_public_path__ + "img/Rectangle 75422.0d93231d.png";